module.exports = __webpack_public_path__ + "img/emoji_07.09b012e1.png";